/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { resetPrepare, updateWaterBodyDefinitions } from './actions';
import { WaterBodyDefinition } from './models';

interface PrepareState {
  waterBodyDefinitions: WaterBodyDefinition[] | undefined;
}

const initialState: PrepareState = {
  waterBodyDefinitions: undefined,
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(updateWaterBodyDefinitions, (state, action) => {
    state.waterBodyDefinitions = action.payload;
  });

  builder.addCase(resetPrepare, (state) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state = initialState;
  });
});
